import envVar from '../config/envVars';
import { CreateHashtagRequest, Hashtag } from '../types/hashtagsType';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

const getHashtags = async (): Promise<Hashtag[]> => {
  const response = await httpGet(`${envVar.REACT_APP_BASE_API_URL}/hashtags`);
  return response.data;
};

const createHashtag = async (
  hashtag: string,
  keywords: string[] = [],
  groups: string[] = []
): Promise<Hashtag> => {
  const payload: CreateHashtagRequest = { hashtag, keywords, groups };
  const response = await httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/hashtags`,
    payload
  );
  return response.data;
};

const hashtagsApi = {
  getHashtags,
  createHashtag
};
export default hashtagsApi;
